import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { useKanbanContext } from "~/components/KanbanView/Providers/KanbanProvider";
import { currentKanbanGroupByCustomFieldIdSelector } from "~/store/configViews/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
import { DndKanbanManager } from "./DndKanbanManager/DndKanbanManager";
import { KanbanColumnsManager } from "./KanbanColumnsManager/KanbanColumnsManager";
export const KanbanColumnsManagers = /*#__PURE__*/ memo((param)=>{
    let { loadingState, baseCustomField } = param;
    const customFieldId = useAirSelector(currentKanbanGroupByCustomFieldIdSelector);
    const { customFieldValues } = useKanbanContext();
    // loadingState is passed in to prevent flicker
    if (!customFieldValues || !customFieldId || !baseCustomField) return loadingState;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(KanbanColumnsManager, {}, customFieldId),
            /*#__PURE__*/ _jsx(DndKanbanManager, {
                baseCustomField: baseCustomField
            })
        ]
    });
});
KanbanColumnsManagers.displayName = "KanbanColumnsManagers";
